import { render, staticRenderFns } from "./exportAndImport.vue?vue&type=template&id=40039b21&scoped=true"
import script from "./exportAndImport.vue?vue&type=script&lang=js"
export * from "./exportAndImport.vue?vue&type=script&lang=js"
import style0 from "./exportAndImport.vue?vue&type=style&index=0&id=40039b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40039b21",
  null
  
)

export default component.exports